import React, {Fragment} from 'react';
import InputComponent from "../../components/InputComponent/InputComponent";

function ReservationForm(props) {
    let user = JSON.parse(localStorage.getItem('user'));
    let isValid = (user.role !== "ROLE_ANONYMOUS");
    console.log("reservationFormData object: ", props.reservationFormData);
    return (
        <Fragment>
            {isValid ?
                <Fragment>

                        <div className="card">
                            <div className="card-body">
                                <hr/>
                                <br/>
                                <form onSubmit={props.reservationSubmit}>
                                    <InputComponent
                                        label="Guest name:"
                                        type="text"
                                        object={props.reservationFormData.guestName}
                                        name="guestName"
                                        inputChangeHandler={props.inputChangeHandler}
                                        placeholder=""
                                        isJustForAdmin={true}
                                    />

                                    < div className="form-group">
                                        <label>Check-in and check-out dates: </label>
                                        <input
                                            type="date"
                                            className="form-control datepicker"
                                            name="startDate"
                                            value={props.reservationFormData.startDate.value}
                                            onChange={props.inputChangeHandler}
                                        />
                                        <span> — </span>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="endDate"
                                            value={props.reservationFormData.endDate.value}
                                            onChange={props.inputChangeHandler}
                                        />
                                        <small
                                            className="form-text error-block">{props.reservationFormData.endDate.message}</small>
                                    </div>
                                    <button className="btn btn-primary btn-round" type="submit">Reserve room</button>
                                </form>
                            </div>
                        </div>

                </Fragment> : <Fragment><h3>Log in or register for a reservation</h3></Fragment>
            }
        </Fragment>

    )
}

export default ReservationForm;


// WEBPACK FOOTER //
// ./src/components/ReservationForm/ReservationForm.jsx